import { useState } from 'react';

import { Typography, Button, Dialog, DialogActions, DialogContentText, DialogTitle, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import { StyledLoadingButton } from '../../../../../components/forms/LoadingButton';
import AdminIntegrationsContainer from '../../../AdminIntegrationsContainer';

const StyledLabelFieldDiv = styled.div`
    display: flex;
    flex-direction: column;
`;
const SharedSecretDiv = styled.div`
    margin-top: 24px;
    display: flex;
    align-items: flex-end;
`;
const CopyButton = styled(Button)`
    margin-left: 12px;
`;

interface SharedSecretProps {
    sharedSecret: string;
}

const SharedSecret: React.FC<SharedSecretProps> = ({ sharedSecret }) => {
    const { t } = useTranslation('admin_settings');
    const { regenerateSecret } = useContainer(AdminIntegrationsContainer);
    const [secret, setSecret] = useState<string>(sharedSecret);
    const [regenerateDialogOpen, setRegenerateDialogOpen] = useState<boolean>(false);
    const [regenerating, setRegenerating] = useState<boolean>(false);

    const copySecret = () => {
        navigator.clipboard.writeText(secret);
    };

    const handleRegenSecret = async () => {
        setRegenerating(true);
        const record = await regenerateSecret();
        setSecret(record.shared_secret);
        setRegenerating(false);
        setRegenerateDialogOpen(false);
    };
    return (
        <>
            <SharedSecretDiv>
                <StyledLabelFieldDiv>
                    <Typography>{t('shared-secret')}</Typography>
                    <Typography variant="body2">{secret}</Typography>
                </StyledLabelFieldDiv>
                <CopyButton variant='outlined' onClick={copySecret}>{t('copy')}</CopyButton>
                <CopyButton variant='outlined' color='error' onClick={() => setRegenerateDialogOpen(true)}>{t('regenerate')}</CopyButton>
            </SharedSecretDiv>
            <Dialog
                open={regenerateDialogOpen}
                onClose={() => setRegenerateDialogOpen(false)}
            >
                <DialogTitle>{t('regenerate-secret')}</DialogTitle>
                <DialogContent>
                    <DialogContentText color='text.primary'>
                        {t('confirm-regenerate')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setRegenerateDialogOpen(false)}>{t('cancel')}</Button>
                    <StyledLoadingButton variant="contained" color="error" onClick={handleRegenSecret} loading={regenerating}>{t('regenerate')}</StyledLoadingButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SharedSecret;
